import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Inject,
    Input,
    Optional,
    Output,
    ViewChild
} from '@angular/core';
import { NgModel, NG_ASYNC_VALIDATORS, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { keyboard } from '@ridango/core/lib/enums/keyboard.enum';

import { animations } from './../../generic/form/animations';
import { ElementBase } from './../../generic/form/element-base';

let identifier = 0;

@Component({
    selector: 'ridango-dropdown-filter-wcag',
    templateUrl: './dropdown-filter-wcag.component.html',
    animations,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: DropdownFilterWcagComponent,
            multi: true
        }
    ]
})
export class DropdownFilterWcagComponent extends ElementBase<string> {
    @Input() public label: string;

    @Input() public placeholder = 'Default placeholder';

    @Input() public showErrors: boolean;

    @Input() items: any[];

    @Input() filter: string;

    @Input() selectedItem: any;

    @Input() searchFromStart = false;

    @Input() required = false;

    public isOpen = false;

    @ViewChild(NgModel, { static: true }) model: NgModel;

    @ViewChild('autocompleteOptions') optionsList: ElementRef;

    @Output() valueChanged = new EventEmitter<string>();

    @Output() filterCleared = new EventEmitter<string>();

    @Output() onTabPressedEvent = new EventEmitter<string>();

    @Output() onShiftTabPressedEvent = new EventEmitter<string>();

    @Output() onItemSelected = new EventEmitter<any>();

    filteredArray = [];

    filterValue = '';

    childElements: any = [];

    dirty = false;

    public selectedIndex = 0;

    public identifier = `filter-dropdown-${++identifier}`;

    public inputIdentifier = `filter-dropdown-${++identifier}-uniq`;

    public labelId = `label-${identifier}`;

    public listBoxId = `listbox-${identifier}`;

    public listItemIdPrefix = `${this.listBoxId}-item-`;

    constructor(
        public eRef: ElementRef,
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>
    ) {
        super(validators, asyncValidators);
    }

    @HostListener('document:click', ['$event']) onClickOut(event) {
        if (this.filteredArray.length === 0) {
            this.filteredArray = this.items;
        }
        if (!this.eRef.nativeElement.contains(event.target)) {
            if (this.selectedIndex === -1) {
                this.selectedIndex = 0;
            }
            this.selectedIndex = -1;
            this.isOpen = false;
            if (this.dirty && this.filteredArray.length === 0) {
                this.itemSelected(null);
            } else {
                if (this.dirty && this.filteredArray.length) {
                    // this.selectedIndex = 0;
                    if (this.filter && this.filter !== '') {
                        const item = this.filteredArray[this.selectedIndex];
                        this.itemSelected(item);
                    } else {
                        this.itemSelected(null);
                    }
                }
            }
        }
    }

    filterChanged() {
        this.dirty = true;
        if (this.filter && this.filter !== '') {
            this.selectedIndex = 0;
            this.filteredArray = this.items.filter((item) => {
                if (this.searchFromStart) {
                    return item.name.toLowerCase().indexOf(this.filter.toLowerCase()) === 0;
                }
                return item.name.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0;
            });
            if (this.filteredArray.length === 0) {
                this.isOpen = false;
            }
        } else {
            this.dirty = true;
            this.selectedIndex = -1;
            this.filteredArray = this.items;
            this.onItemSelected.emit(null);
            // this.clearFilter();
        }
    }

    keyDown(event: KeyboardEvent) {
        this.showErrors = false;
        this.isOpen = false;

        if (this.filteredArray.length) {
            switch (event.code) {
                case keyboard.ARROW_DOWN:
                    this.dirty = true;
                    const total: number = this.filteredArray.length;
                    if (this.selectedIndex < total - 1) {
                        this.selectedIndex++;
                    } else {
                        this.selectedIndex = 0;
                    }
                    this.isOpen = true;
                    break;
                case keyboard.ARROW_UP:
                    this.dirty = true;
                    if (this.selectedIndex > 0) {
                        this.selectedIndex--;
                    } else {
                        this.selectedIndex = 0;
                    }
                    this.isOpen = true;
                    break;
                case keyboard.ENTER:
                    if (this.dirty) {
                        this.itemSelected(this.filteredArray[this.selectedIndex]);
                    }
                    this.dirty = false;
                    break;
                case keyboard.TAB:
                    if (this.dirty) {
                        this.itemSelected(this.filteredArray[this.selectedIndex]);
                        this.selectedIndex = 0;
                    }
                    this.dirty = false;
                    break;
                case keyboard.ESCAPE:
                    this.selectedIndex = -1;
                    this.isOpen = false;
                    this.filter = '';
                    this.filterChanged();
                    break;
                default:
                    this.selectedIndex = 0;
                    this.isOpen = true;
            }
        }
    }

    onFocus(): any {
        this.isOpen = true;
        this.filteredArray = this.items;
        if (this.selectedItem) {
            this.selectedIndex = this.items.findIndex((item) => item.name === this.selectedItem.name);
        } else {
            this.selectedIndex = 0;
        }
    }

    clearFilter() {
        this.filter = '';
        this.filteredArray = this.items;
        this.showErrors = false;
        this.dirty = false;
        this.onItemSelected.emit(null);
        this.itemSelected(null);
        // this.optionsList.nativeElement.scrollTop = 0;
        // this.selectedIndex = 0;
    }

    itemSelected(item) {
        this.selectedIndex = -1;
        this.selectedItem = item;
        this.writeValue(null);
        if (item) {
            this.filter = item.name;
            this.writeValue(item.id);
        } else {
            this.filter = null;
            this.writeValue(null);
        }
        this.dirty = false;
        this.isOpen = false;
        this.filteredArray = this.items;
    }

    itemSelectedFromList(item) {
        this.itemSelected(item);
        this.onItemSelected.emit(item);
    }
}
